const DEFAULT_PORTFOLIO_APP_HOST = "portfolio.metalui.co.uk";
const HOST_LABEL_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export function resolvePortfolioAppHost(configuredHost?: string): string {
  const host = configuredHost?.trim().toLowerCase().replace(/\.$/, "");
  if (!host) return DEFAULT_PORTFOLIO_APP_HOST;

  const labels = host.split(".");
  if (
    host.length > 253 ||
    labels.some(
      (label) =>
        label.length > 63 || !HOST_LABEL_PATTERN.test(label),
    )
  ) {
    throw new Error(
      "VITE_PORTFOLIO_APP_HOST must be a hostname only, without a scheme, port, path, or query.",
    );
  }
  return host;
}